import { ChainId_Internal } from '../types';
export const NATIVE_TOKEN_ADDRESS = '0x0000000000000000000000000000000000000000';
export const WRAPPED_NATIVE_TOKEN_BY_CHAIN = {
    [ChainId_Internal.ZK_EVM]: {
        address: '0xC1bF55EE54E16229d9b369a5502Bfe5fC9F20b6d',
        symbol: 'wzkCRO',
        decimals: 18,
    },
    [ChainId_Internal.ZK_EVM_TEST]: {
        address: '0xeD73b53197189BE3Ff978069cf30eBc28a8B5837',
        symbol: 'wzkTCRO',
        decimals: 18,
    },
    [ChainId_Internal.CRONOS_EVM_MAINNET]: {
        address: '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23',
        symbol: 'WCRO',
        decimals: 18,
    },
    [ChainId_Internal.CRONOS_EVM_TESTNET]: {
        address: '0x6a3173618859C7cd40fAF6921b5E9eB6A76f1fD4',
        symbol: 'WCRO',
        decimals: 18,
    },
    [ChainId_Internal.ETHEREUM]: {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        symbol: 'WETH',
        decimals: 18,
    },
    [ChainId_Internal.SEPOLIA]: {
        address: '0x32375B523fcD7C768Ee0E75D3b98de1B4e5c2db3',
        symbol: 'WETH',
        decimals: 18,
    },
};
export const BASE_USD_TOKEN_BY_CHAIN = {
    [ChainId_Internal.ZK_EVM]: {
        address: '0x5b91e29ae5a71d9052620acb813d5ac25ec7a4a2',
        symbol: 'vUSD',
        decimals: 18,
    },
    [ChainId_Internal.ZK_EVM_TEST]: {
        address: '0x9553dA89510e33BfE65fcD71c1874FF1D6b0dD75',
        symbol: 'vUSD',
        decimals: 18,
    },
    [ChainId_Internal.CRONOS_EVM_MAINNET]: {
        address: '0xc21223249CA28397B4B6541dfFaEcC539BfF0c59',
        symbol: 'USDC',
        decimals: 6,
    },
    [ChainId_Internal.CRONOS_EVM_TESTNET]: {
        address: '0x321106E51b78E0E9CEBcFeC63C5250F0F3CcB82b',
        symbol: 'USDC',
        decimals: 6,
    },
    [ChainId_Internal.ETHEREUM]: {
        address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        symbol: 'USDC',
        decimals: 6,
    },
    [ChainId_Internal.SEPOLIA]: {
        address: '0x3a62C8A4cD4Bd16d4f39D018396E2c9eCD99B865',
        symbol: 'USDC',
        decimals: 6,
    },
};
